import { AsyncPipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { subscribeOnce } from '@tmx/core';
import { Observable } from 'rxjs';

import { SecondaryNavKey } from './models/secondary-nav-key';
import { SecondaryNavOption } from './models/secondary-nav-option';
import { observeSecondaryNavOptions } from './repositories/secondary-nav.repository';

@Component({
  selector: 'app-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  styleUrls: ['./secondary-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, RouterLinkActive, RouterLink, AsyncPipe],
})
export class SecondaryNavComponent {
  options$: null | Observable<SecondaryNavOption[]> = null;
  numberOfOptions = 0;

  @Input() set key(value: SecondaryNavKey) {
    this.options$ = observeSecondaryNavOptions(value);
    subscribeOnce(this.options$, (options) => {
      this.numberOfOptions = options.length;
    });
  }
  @Input() active = false;
}
